import React from 'react';
import { SearchModelBase } from '../../fms.data/models/SearchModelBase';

export interface RightClickContext {
  row: number,
  column: number,
  node: Element,
  status : boolean,
};

export interface IJobListViewContext {
  selectedElement: any|null,
  hasOpenedScreenStartingWithUrl: (url:string) => boolean,
  hasOpenedScreenStartingWithUrlWithoutMe: (url:string, ignoreUrl: string) => boolean,
  hasOpenedScreenInAnyOperationStartingWithUrl: (url: string) => boolean,
  hasOpenedScreenInAnyOperationStartingWithUrlWithoutMe: (url: string, ignoreUrl: string) => boolean,
  getOpenedScreenInAnyOperationStartingWithUrl: (url: string) => any,
  moveToOpenedScreenInAnyOperationStartingWithUrl: (oepnRequestUrl:string, queryUrls:string[], needAfterScreenUrl?: boolean|undefined) => any,
  reloadData: () => void,
  triggerTableSearch: (fkey:string) => boolean,
  setFilterForScreenExternally: (url:string, columnId:string, columnLabel:string, text:string|number, orderBy:any, orderByAscending:boolean, startWithEntry?:boolean, searchModel?:SearchModelBase|null, columnIdEx?:string|null, textEx?:string|number|null, isExpressSearch?:boolean, switchList?:boolean) => void,
  setFilterForSearchModel: (url:string, searchModel:SearchModelBase|null, filterOrderObj: any) => void,
  infoAreaContent: string,
  setInfoAreaContent: (c:string) => void,
  updateDataRow: (row:any, insertIfNotExist?:boolean) => void,
  openedByF6: boolean,
  f6Origin: string|null,
  f6Query: string|null,
  rowExtrasId: number|null,
  setRowExtrasId: (id: number|null) => void,
  setClickedCell: (data: any) => void,
  setData?: (data: any, count: number) => void,
  data?: any[],
  viewPopupRow: any|undefined,
  dismissPopupRow: VoidFunction,
  showPopupRow: VoidFunction,
  opType: string|undefined,
  search:any,
  setListFilterType:(data: any) => void,
  trackingRequestEmailList: string|undefined,
  setTrackingRequestEmailList: (data: string|undefined) => void,
  recogModalData: { isSet: boolean; isOpen: boolean } | undefined;
  setRecogModalData: React.Dispatch<React.SetStateAction<{ isSet: boolean; isOpen: boolean }>>;
  setListOrderBy:(data: any) => void,
  setListFilterOrder:(x: any) => void,
  setListFilterType2:(data: any) => void,
};

const defaultState:IJobListViewContext = {
  selectedElement: null,
  hasOpenedScreenStartingWithUrl: () => false,
  hasOpenedScreenStartingWithUrlWithoutMe: () => false,
  hasOpenedScreenInAnyOperationStartingWithUrl: () => false,
  hasOpenedScreenInAnyOperationStartingWithUrlWithoutMe: () => false,
  getOpenedScreenInAnyOperationStartingWithUrl: () => {},
  moveToOpenedScreenInAnyOperationStartingWithUrl: () => {},
  reloadData: () => {},
  triggerTableSearch: () => false,
  setFilterForScreenExternally: () => {},
  setFilterForSearchModel:() => {},
  infoAreaContent: 'none',
  setInfoAreaContent: () => {},
  updateDataRow: (row:any) => {},
  openedByF6: false,
  f6Origin: null,
  f6Query: null,
  rowExtrasId: null,
  setRowExtrasId: () => {},
  setClickedCell: () => {},
  setData: () => {},
  data: [],
  viewPopupRow: undefined,
  dismissPopupRow: () => {},
  showPopupRow: () => {},
  opType: undefined,
  search:null,
  setListFilterType: (data:any) => {},
  trackingRequestEmailList: undefined,
  setTrackingRequestEmailList: () => {},
  recogModalData: undefined,
  setRecogModalData: () => {},
  setListOrderBy: (data: any) => {},
  setListFilterOrder: () => {},
  setListFilterType2: (data:any) => {},
};

const JobListViewContext = React.createContext<IJobListViewContext>(defaultState);

export default JobListViewContext;
